module.exports = __webpack_public_path__ + "static/media/video-yardnapha-runoff.efeca44a.png";